import React from 'react';
import { useTranslation } from 'react-i18next';
import noop from 'lodash/noop';
import { Tooltip } from '@web-chat-core/ui-kit';
import { LoadingIcon, SummaryButtonLayout } from './view';

interface Props {
    isMobile?: boolean;
}

export const InProgressSummaryButton: React.FC<Props> = ({ isMobile }) => {
    const { t } = useTranslation();

    return (
        <Tooltip label={t('web_videoconference_AI_Assistant_turn_on_tooltip_button')}>
            <SummaryButtonLayout onClick={noop} $isMobile={isMobile}>
                <LoadingIcon icon="icSpinnerLarge" size={24} />
            </SummaryButtonLayout>
        </Tooltip>
    );
};
